module.exports = __webpack_public_path__ + "static/img/index_img_4.073a6e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index_img_4.jpg
// module id = e+Xx
// module chunks = 0